import { type ComponentRef, forwardRef } from 'react';

import { Button, type ButtonProps } from '@opendoor/atoms/button';
import { cn } from '@opendoor/atoms/utils';

export const PdpRaisedButton = forwardRef<ComponentRef<typeof Button>, ButtonProps>(
  function PdpRaisedButton({ className, ...props }, ref) {
    return (
      <Button
        {...props}
        ref={ref}
        className={cn(
          'rounded-xl border-[#d7d4cd] shadow-[0_2px_3px_0_rgba(137,134,127,0.1)] not-disabled:active:shadow-none disabled:not-aria-busy:shadow-none aria-disabled:shadow-none',
          className,
        )}
      />
    );
  },
);

PdpRaisedButton.displayName = 'PdpRaisedButton';
